<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;margin-left: 6px;" label="选择日期：">
        <el-date-picker :picker-options="dataForm.pickerOptions" v-model="dataForm.dateStr" type="daterange"
          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="float: left;" label="选择设备：">
        <template>
          <el-input v-model="value" @click.native="handleClick" placeholder="输入关键字进行过滤" style="width: 300px;"
            clearable></el-input>
          <el-tree id="el_Tree" class="filter-tree" :data="hTree" :check-strictly="true"
            :filter-node-method="filterNode" ref="tree" @node-click="handleCheckChange" v-show="isiptShow">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!--给设备追加图标-->
              <i v-if="data.deviceStatus == 1" class="iconfont"><img src="../../assets/img/yq01.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 2" class="iconfont"><img src="../../assets/img/yq02.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 3" class="iconfont"><img src="../../assets/img/yq03.png" alt="" width="16"
                  height="16"></i>
              <i v-if="data.deviceStatus == 4" class="iconfont"><img src="../../assets/img/yq04.png" alt="" width="16"
                  height="16"></i>
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </template>
      </el-form-item>
      <el-button @click="getDataList()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button type="success" @click="tempExcel()" v-show="isShow">导出Excel</el-button>
      </el-form-item>
    </el-form>
    <p class="list-p" v-if="dataList == 0" @click="isiptShow = false">
      <i class="el-icon-warning"></i>
      {{ this.msg }}
    </p>
    <el-table v-show="isShow" :data="dataList" v-loading="dataListLoading" :span-method="arraySpanMethod"
      @selection-change="selectionChangeHandle" style="width: 100%;" height="calc(100% - 120px)" border stripe
      :header-cell-style="{background:'#FAFAFA'}" placement="top">
      <el-table-column prop="name" header-align="center" align="center" label="设备名称">
      </el-table-column>
      <el-table-column prop="uniqueCode" header-align="center" align="center" label="设备唯一编码">
      </el-table-column>
      <el-table-column prop="address" header-align="center" align="center" label="点位">
      </el-table-column>
      <el-table-column prop="companyName" header-align="center" align="center" label="企业名称">
      </el-table-column>
      <el-table-column prop="recordDate" header-align="center" align="center" label="日期" sortable>
      </el-table-column>
      <el-table-column prop="totalLostCount" header-align="center" align="center" label="缺失数">
      </el-table-column>
      <el-table-column prop="lostRate" header-align="center" align="center" label="缺失率">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click="detailsHandle(scope.row.deviceId)"><i class="el-icon-data-analysis"
              style="font-size: 18px;vertical-align: text-bottom;"></i>查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: calc(100% - 120px);float: left;width: 100%;" v-show="detaildialog">
      <div style="clear: both;display: block;text-align: left;font-weight: bold;font-size: 16px;">
        <label>设备名称：</label>
        <span style="font-weight: initial;min-width: 250px;display: inline-block">{{ dataFormrl.companyName }}</span>
        <label>所属点位：</label>
        <span style="font-weight: initial;">{{ dataFormrl.poiName }}</span>
        <br>
        <label>设备名称：</label>
        <span style="font-weight: initial;min-width: 250px;display: inline-block">{{ dataFormrl.deviceName}}</span>
        <label>唯一编码：</label>
        <span style="font-weight: initial;">{{ dataFormrl.uniqueCode }}</span>
      </div>
      <el-table :data="tableHead" :header-cell-style="{background:'#172556',color:'#fff'}" style="width: 100%;"
        height="calc(100% - 50px)" placement="top" stripe border>
        <el-table-column align="center" label="缺失时间点">
          <template slot-scope="scope">
            <label>{{scope.row}}</label>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination v-show="isShow" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
      :current-page="pageIndex" :page-sizes="[10,15, 20, 50]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
  </div>
</template>
<style scoped>
 .list-p {
   clear: both;
   height: calc(100% - 100px);
   display: flex;
   justify-content: center;
   align-items: center;
   font-size: 40px;
}

.list-p .el-icon-warning {
  font-size: 50px;
  vertical-align: middle;
}
 .el-tree {
   background: #eee;
   height: 300px;
   overflow-y: scroll;
   z-index: 9999;
   position: absolute;
   width: 100%;
 }
</style>
<script>
import {excel} from "@/utils";

export default {
  data() {
    return {
      dataForm: {
        dateFromStr: '',
        dateToStr: '',
        dateStr: '',
        deviceId: "",
        key: '',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() >Date.now()
          }
        }
      },
      dataList: [],
      pageIndex: 1,
      msg: '请输入您的查询条件',
      pageSize: 15,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      value1: '',
      options: [],
      value: '',
      isShow: false,
      isiptShow:false,
      hTree: [],
      dataFormrl: [],
      tableHead:[],
      detaildialog: false,
      detaildialoglist:true,
      dcxq:""
    }
  },
  created() {
    //动态设置默认时间
    this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "weeks").format("yyyy-MM-DD"),
      this.$moment(new Date()).format("yyyy-MM-DD")]
    this.queryPoint();
    this.hTree = JSON.parse(sessionStorage.getItem("hTree") || "[]");
  },
  watch: {
    value(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    detailsHandle(deviceId){
      this.dcxq = deviceId;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.dataForm.dateFromStr = this.dataForm.dateStr[0]
      this.dataForm.dateToStr = this.$moment(this.dataForm.dateStr[1]).add(0, 'days').format("yyyy-MM-DD")
      this.$http({
        url: this.$http.adornUrl('dataDailyLostView/details'),
        method: 'get',
        params: this.$http.adornParams({
          'deviceId': deviceId,
          'dateFromStr': this.dataForm.dateFromStr,
          'dateToStr': this.dataForm.dateToStr,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          loading.close();
          this.detaildialog = true;
          this.isShow = false
          this.tableHead = data.data.detail.deviceRecordTime
          this.dataFormrl = data.data.detail.lostVoList[0]
        }else {

        }
      })
    },
    handleClick(){
      this.isiptShow = true;
    },
    //节点选中状态发生变化时的回调
    handleCheckChange(data) {
      if (data.deviceId) {
        this.value = data.label
        this.dataForm.deviceId = data.deviceId
      }
      if (data.children.length == 0) {
        this.isiptShow = false
      }
      // this.isiptShow = false
    },
    //节点过滤
    filterNode(value, data) {
      if (!value) return true;
      if (!data.label) return false;
      if (!data.uniqueCode) return false;
      return data.label.indexOf(value) !== -1 || data.uniqueCode.indexOf(value) !== -1
    },
    // 获取数据列表
    getDataList() {
      this.detaildialog = false
      this.dataList = [];
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (!this.dataForm.deviceId) {
        this.$message.warning(this.msg)
        loading.close();
        return
      }
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateStr[1]).add(1, 'days').format("yyyy-MM-DD")
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      //下拉框是否有选中
      if (this.value === '') {
        this.msg = this.labelNew
        this.$message.warning('请' + this.labelNew)
        loading.close();
        return
      }
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/dataDailyLostView/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'deviceId': this.dataForm.deviceId,
          'dateFromStr': this.dataForm.dateFromStr,
          'dateToStr': this.dataForm.dateToStr,
        })
      }).then(({data}) => {
        loading.close();
        if (data && data.code === 200) {
          this.isShow = true;
          this.isiptShow = false;
          this.dataList = data.data.rows;
          this.totalPage = data.data.total;
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.msg = data.msg
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    //导出excel
    tempExcel() {
      if (this.value === '') {
        this.msg = this.labelNew
        this.$message.warning('请' + this.labelNew)
        return
      }
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateStr[1]).add(1, 'days').format("yyyy-MM-DD")
      } else {
        this.msg = "请选择时间";
        this.$message.warning(this.msg)
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      excel("/dataDailyLostView/excel", this.value + "-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'deviceId': this.dataForm.deviceId,
        'dateFromStr': this.dataForm.dateFromStr,
        'dateToStr': this.dataForm.dateToStr,
      },loading.close(),this.$message({
          message: '导出成功',
          type: 'success',
          duration: 3000,
          showClose:true,
          onClose: () => {}
        })
      )
    },
    //  查询点位
    queryPoint() {
      //设备下拉框
      this.$http({
        url: this.$http.adornUrl('/device/option'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.options = data.data.deviceOption;
        }
      })
    },
    //合并操作，每一个格子都会掉一遍此方法
    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      //前4列，才合并行
      if (columnIndex <= 3) {
        //第1行的前五列的格子，每一个格子只合并一次，一次合并20行，设备的通道因子最多也就15个
        if (rowIndex === 0) {
          return {
            rowspan: this.pageSize,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 7) {
        if (rowIndex === 0) {
          return {
            rowspan: this.pageSize,
            colspan: 1
          };
        } else {
          //去掉其他的格子
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/datacenter/dataDailyLost.vue